<template>
  <div class="container mx-auto pt-5">
    <h1 class="font-bold text-3xl mb-4">
      Déco de couleur {{ resolve.content.attributes.name.fr }}
    </h1>
    <div class="mb-5">
      <div class="flex flex-wrap">
        <nuxt-link
          v-for="color in resolve.colorFacets"
          :key="color.value.link_rewrite"
          :style="{
            width: '30px',
            height: '30px',
            backgroundColor: color.value.code,
            borderRadius: '20px',
            border: color.value.code === '#FFFFFF' ? '1px solid black' : undefined
          }"
          :to="`/couleur-${color.value.link_rewrite}`"
          class="m-1"
        />
      </div>
    </div>
    <div class="flex flex-wrap">
      <div
        v-for="product in resolve.products"
        :key="product.sku"
        class="md:w-1/5 px-2"
      >
        <product-card
          :product="product"
        />
      </div>
    </div>
    <div class="sky__color-description" v-html="renderedContent" />
  </div>
</template>

<script>
import { marked } from 'marked'
import ProductCard from '../general/ProductCard'

export default {
  components: {
    ProductCard
  },
  props: {
    resolve: {
      type: Object,
      required: true
    }
  },
  computed: {
    renderedContent () {
      if (!this.resolve.content.attributes.cms_content) {
        return null
      }
      return marked(this.resolve.content.attributes.cms_content)
    }
  },
  mounted () {
    this.$gtmEvents.onRegularPageView()
  }
}
</script>

<style lang="scss">
.sky__color-description {
  @apply py-10 px-4;
  @screen lg {
    @apply mx-auto;
    // column-count: 2;
    // column-gap: 50px;
    max-width: 900px;
  }
  h2 {
    @apply font-funny text-3xl mb-3 text-center;
    line-height: 3rem;
    @screen lg {
      @apply text-5xl;
    }
  }
  h3 {
    @apply font-bold mb-2;
  }
  p {
    @apply text-sm mb-3 text-justify;
  }
}
.sky__category-more-description {
  @apply text-sm pt-5 pb-0 px-3;
  h2 {
    @apply text-base font-bold my-1;
  }
  p {
    @apply mb-2 text-xs;
  }
}

</style>
